import { area } from "d3-shape";
import { ComputedSerie, Datum, Layer } from "@nivo/line";
import { Scale } from "@nivo/scales";
import { getCurveType } from "src/components/monitoring/ChartLines";

export const CustomLinearGradient = (chartTypeId: string, gradientColor: string | undefined, softGradient: boolean): Layer => {
    const gradientId = "gradient-" + chartTypeId;
    return () => (
        <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor={gradientColor} stopOpacity={softGradient ? "0.15" : "0.75"} />
                <stop offset="100%" stopColor={gradientColor} stopOpacity={softGradient ? "0.15" : "0.25"} />
            </linearGradient>
        </defs>
    );
};

export const CustomAreaLayerGradientLayer = (
    chartTypeId: string,
    curve?: "linear" | "monotoneX" | "monotoneY" | "natural" | "step" | "stepBefore" | "stepAfter",
): Layer => {
    return ({ series, xScale, yScale }) => {
        const lines = series.findIndex((serie) => serie.id === chartTypeId);
        return BasicAreaLayerGradient({
            lineIndex: lines,
            series: series,
            xScale: xScale,
            yScale: yScale,
            curve,
        });
    };
};

const BasicAreaLayerGradient = ({
    lineIndex,
    series,
    xScale,
    yScale,
    curve = "monotoneX",
}: {
    lineIndex: number;
    series: readonly ComputedSerie[];
    xScale: Scale<unknown, unknown>;
    yScale: Scale<unknown, unknown>;
    curve?: "linear" | "monotoneX" | "monotoneY" | "natural" | "step" | "stepBefore" | "stepAfter";
}) => {
    const pointsWithArea = lineIndex !== -1 ? series[lineIndex].data.filter((point) => point.data.hasArea) : [];

    if (pointsWithArea.length === 0) return null;

    const areaGenerator = area<Datum>()
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .x((d) => xScale(d.data.x))
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .y0(yScale(0)) // untere Grenze des Bereichs, hier setzen wir es auf die x-Achse
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .y1((d) => yScale(d.data.y)) // obere Grenze des Bereichs
        .curve(getCurveType(curve));

    const finalPath = areaGenerator(pointsWithArea);

    return <path data-testid={"gradient" + lineIndex} d={finalPath ?? undefined} fill={pointsWithArea[0].data.fill} />;
};
